<template>
  <dialog
    v-show="showModal"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-description"
    aria-modal="true"
    :class="[{ 'modal-mask-progress': showProgress, 'modal-mask': !showProgress }]"
    style="padding: 0px"
  >
    <div
      :class="[
        {
          'modal-wrapper-progress': showProgress,
          'modal-wrapper': !showProgress,
          'modal-video-wrapper': showPlayer
        }
      ]"
    >
      <div
        :class="[{ 'modal-container-progress': showProgress, 'modal-container': !showProgress }]"
      >
        <div :class="[{ 'modal-body-progress': showProgress, 'modal-body': !showProgress }]">
          <!-- VIDEO PLAYER HERE -->
          <div v-if="showPlayer" class="video-player-container">
            <video-player></video-player>
          </div>

          <!-- PROGRESS PATH HERE -->
          <div v-if="showProgress" class="progressScreen">
            <progress-path></progress-path>
          </div>

          <!-- CERTIFICATE -->
          <div v-if="showCertificate" class="certScreen">
            <certificate></certificate>
          </div>

          <!-- ERROR -->
          <div v-if="showError" class="errorScreen">
            <oops :hide-tell-teacher="modalData && modalData.hideTellTeacher"></oops>
          </div>

          <!-- KEYBOARD Error -->
          <div v-if="showKeyboardError">
            <keyboard-error></keyboard-error>
          </div>

          <!-- KEYBOARD Error -->
          <div v-if="showTextHelper">
            <show-text-helper
              :heading="modalData.heading"
              :text="modalData.text"
            ></show-text-helper>
          </div>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Certificate from './Certificate.vue';
import KeyboardError from './KeyboardError.vue';
import Oops from './Oops.vue';
import ProgressPath from './ProgressPath.vue';
import VideoPlayer from './VideoPlayer.vue';
import ShowTextHelper from './ShowTextHelper.vue';

export default {
  data() {
    return {
      modalData: null,
      onCloseModalCb: null,
      showCertificate: false,
      showError: false,
      showKeyboardError: false,
      showModal: false,
      showPlayer: false,
      showProgress: false,
      showTextHelper: false
    };
  },

  computed: {
    ...mapState('application', ['modal']),
    ...mapState('activity', {
      activityData: state => state.data
    })
  },

  watch: {
    showModal(shouldShow) {
      if (shouldShow) {
        this.toggleModalFocus(true);
        return;
      }
      this.toggleModalFocus(false);
    },
    modal(newModal, oldModal) {
      if (!this.modal) {
        this.setVideoData({});
        this.triggerCloseModal();
        return;
      }

      if (newModal.data?.id && oldModal?.data?.id && newModal.data.id !== oldModal.data.id) {
        this.triggerCloseModal();
      }

      this.$nextTick(() => {
        this.currentModal = newModal;
        this.triggerShowModal(this.modal.type, this.modal.data, this.modal.onClose);
      });
    }
  },

  components: {
    VideoPlayer,
    ProgressPath,
    Certificate,
    KeyboardError,
    Oops,
    ShowTextHelper
  },

  mounted() {
    document.querySelector('.modal-mask').addEventListener('keydown', this.onModalMaskKeydown);
  },

  destroyed() {
    document.querySelector('.modal-mask').removeEventListener('keydown', this.onModalMaskKeydown);
  },

  methods: {
    ...mapMutations('application', ['setVideoData']),

    toggleModalFocus(shouldFocus) {
      const mainContent = document.getElementById('mainContent');
      if (!!mainContent) {
        const children = Array.from(mainContent.children);
        children.forEach(child => {
          if (child.tagName === 'DIALOG') return;
          child.inert = shouldFocus;
        });
      }
    },

    openModal(modal) {
      [
        'showCertificate',
        'showError',
        'showKeyboardError',
        'showPlayer',
        'showProgress',
        'showTextHelper'
      ].forEach(modalStr => {
        this[modalStr] = modal === 'none' || modal !== modalStr ? false : true;
      });
    },

    onModalMaskKeydown(event) {
      if (this.showModal && event.key === 'Escape') {
        this.triggerCloseModal();
      }
    },

    triggerCloseModal() {
      if (this.onCloseModalCb) {
        this.onCloseModalCb();
      }

      this.showModal = false;
      this.modalData = null;
      this.onCloseModalCb = null;

      this.openModal('none');
    },

    triggerShowModal(modalType, modalData, onCloseModalCb) {
      this.showModal = true;
      this.modalData = modalData;
      this.onCloseModalCb = onCloseModalCb;

      if (modalType === 'video' || modalType === 'homeRowVideo') {
        this.openModal('showPlayer');
        this.$nextTick(function() {
          this.setVideoData({ video: this.modalData });
        });
      }
      if (modalType === 'progress') {
        this.openModal('showProgress');
      }

      if (modalType === 'cert') {
        this.openModal('showCertificate');
      }

      if (modalType === 'error') {
        this.openModal('showError');
      }

      if (modalType === 'keyboardError') {
        this.openModal('showKeyboardError');
      }

      if (modalType === 'helperText') {
        this.openModal('showTextHelper');
      }
    }
  }
};
</script>
